import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPrimaryActionButton,
  FDBodyText,
  FDStack,
} from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import { fullDateTimeNoSeconds } from 'Consts/DateFormats';
import { formatDateLocal } from 'Consts/DateFormatWithMomentTimezone';
import Portal from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Portal';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder } from 'Components/utils';

export const metaOverrideSet = fr.metaOverride()
  .typeOverride('string', {
    _component: () => TextField,
    multiline: true,
    _customHelperProps: {
      showRequiredHelperText: false,
    },
  });

const useStyles = buildUseStyles('UpdateRequestLayout', (theme) => ({
  root: {
    padding: theme.spacing(2, 0),
    ...getBorder(theme, { bottom: true }),
  },
}));

const Layout = ({
  notesPortalRef,
}) => {
  const { onSubmit, resource } = useMetaLayoutContext();

  const classes = useStyles();

  // If a resource has an id it has been created, and is therefore immutable
  if (resource.id() > 0) {
    return (
      <div className={classes.root}>
        <FDStack direction={'column'} width={1} alignItems="flex-start" justifyContent="flex-start">
          <FDBodyText size={'sm'} value={`${resource.attr('displayName')} at ${formatDateLocal(resource.attr('timestamp'), fullDateTimeNoSeconds)}`} />
          <FDBodyText value={resource.attr('text') ?? ''} size={'md'} />
        </FDStack>
      </div>
    );
  }

  return (
    <Portal container={notesPortalRef?.current}>
      <FDStack direction={'column'} alignItems="flex-start" justifyContent="flex-start">
        <MetaField
          metaOverrideSet={metaOverrideSet}
          attr={'text'}
        />
        <FDPrimaryActionButton
          icon={'add'}
          label={'Add New Note'}
          onClick={() => onSubmit()}
        />
      </FDStack>
    </Portal>
  );
};

Layout.defaultProps = {};

Layout.propTypes = {
  notesPortalRef: PropTypes.object.isRequired,
};

export default Layout;
